module.exports = __webpack_public_path__ + "static/media/035-credit card.6d34f21c.svg";